<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'50%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="120px" :label-position="getIsMobile?'top':'right'" :rules="rules" class="custom-form">
      <el-form-item label="供应商名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入供应商名称"></el-input>
      </el-form-item>
      <el-form-item label="供应商联系人" prop="uname">
        <el-input v-model="form.uname" placeholder="请输入供应商联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入联系人电话"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting';

export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(props,{emit}) {
    const {getIsMobile} = useRootSetting();
    const formRef = ref(null)
    const rules = {
      name: [
        { required: true, message: '供应商名称不能为空', trigger: 'blur' }
      ],
      uname: [
        { required: true, message: '供应商联系人不能为空', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '联系人电话不能为空', trigger: 'blur' }
      ],
    }

    const radio = ref(1)
    const defaultForm = () => ({
      name: '',
      uname:'',
      phone:''
    })
    const form = reactive(defaultForm())

    watch(()=> props.formData, (val)=> {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key];

          // 判断 value 是否为字符串形式的纯数字
          if(form[key]  === '') {
            form[key] = value
            return
          }
          form[key] = typeof value === 'string' && !isNaN(value)
            ? Number(value)
            : value;
        }
      });
    },{deep:true})

    const handleReset = () =>  Object.assign(form, defaultForm())

    const handleSubmit = () => {
        formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }

    const handleClose = () => {
      emit('close')
      handleReset()
    }
    return {
      formRef,
      form,
      rules,
      radio,
      getIsMobile,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
